type ChartColorEntry = {
  backgroundColor: string;
  hoverBackgroundColor: string;
  pointBackgroundColor: string;
  borderColor: string;
};

export const chartColors: Record<string, ChartColorEntry> = {
  performance: {
    backgroundColor: '#B39DDBb4',
    hoverBackgroundColor: '#B39DDBd4',
    pointBackgroundColor: '#B39DDBb4',
    borderColor: '#B39DDBd4',
  },
  fairness: {
    backgroundColor: '#6f9ee6b4',
    hoverBackgroundColor: '#6f9ee6d4',
    pointBackgroundColor: '#6f9ee6b4',
    borderColor: '#6f9ee6d4',
  },
  robustness: {
    backgroundColor: '#9FA8DAb4',
    hoverBackgroundColor: '#9FA8DAd4',
    pointBackgroundColor: '#9FA8DAb4',
    borderColor: '#9FA8DAd4',
  },
  explainability: {
    backgroundColor: '#7DBFD7b4',
    hoverBackgroundColor: '#7DBFD7d4',
    pointBackgroundColor: '#7DBFD7b4',
    borderColor: '#7DBFD7d4',
  },
};
